<script setup>
defineProps(['item', 'type', 'isGray'])
</script>
<template>
	<router-link :to="{ name: 'article', params: { slug: item.slug } }" :class="['link flex gap-6', type === 'main' ? 'flex-col' : 'flex-row', type === 'hero' ? 'flex-col items-center md:flex-row' : '']">
		<div :class="['overflow-hidden rounded-2xl', type === 'main' ? 'h-[320px]' : type === 'hero' ? 'w-full md:w-half' : 'h-[140px] w-[200px] min-w-[200px]']">
			<img :src="item.image" alt="blog image" class="animation aspect-video h-full w-full object-cover scale-100" />
		</div>
		<div :class="['flex flex-col gap-4', type === 'hero' && 'lg:w-half']">
			<div class="flex flex-row gap-4">
				<span class="font-medium text-sm text-primaryLight">
					{{ item.category.name }}
				</span>
				<span v-if="type === 'hero'" class="flex items-center gap-3 font-medium text-sm text-primaryLight">
					<i class="fa-solid fa-calendar" />
					{{
						new Date(item.published_at).toLocaleDateString('en-US', {
							month: 'short',
							day: '2-digit',
							year: 'numeric',
						})
					}}
				</span>
			</div>
			<h6 :class="['title animation line-clamp-3 w-fit border-b pb-1 font-semibold sm:line-clamp-4', isGray ? 'border-bgSecondary' : 'border-bgMain']">
				{{ item.title }}
			</h6>
			<span v-if="type !== 'hero'" class="flex items-center gap-3 font-medium text-sm text-primaryLight">
				<i class="fa-solid fa-calendar" />
				{{
					new Date(item.published_at).toLocaleDateString('en-US', {
						month: 'short',
						day: '2-digit',
						year: 'numeric',
					})
				}}
			</span>
			<span v-if="type === 'hero'" class="font-medium text-primaryLight">
				{{ item.snippet }}
			</span>
		</div>
	</router-link>
</template>
<style scoped>
.link:hover img {
	@apply scale-105;
}

.link:hover .title {
	@apply border-primary;
}
</style>
